export default __webpack_public_path__ + "static/media/480_dummy2016-delikatessen01-mobile.3ed64a2c.png";